import { useState } from 'react'
import { RhyBusButton } from '@rhybus/button'
import { RhyBusPopOver } from '@rhybus/popover'
import { RhyBusTextArea } from '@rhybus/form-controls'
import { cancelTraining } from '../../../services/detailview'

type CancelButtonProps = {
    trainingTrackGUID: string
    trainingTrackId: string
    currentStatusCode: number | null
    userRole: string
    me: any
    onSuccess?: () => void
}

export default function CancelButton({ trainingTrackGUID, trainingTrackId, currentStatusCode, userRole, me, onSuccess }: CancelButtonProps) {
    const [visible, setVisible] = useState(false)
    const [comment, setComment] = useState('')
    const [commentError, setCommentError] = useState('')
    const [loading, setLoading] = useState(false)

    const handleOk = async () => {
        if (!comment.trim()) {
            setCommentError('Comments are required')
            return
        }
        setLoading(true)
        const success = await cancelTraining(trainingTrackGUID, trainingTrackId, comment, currentStatusCode, userRole, me)
        setLoading(false)
        if (success) {
            setVisible(false)
            setComment('')
            setCommentError('')
            onSuccess?.()
        }
    }

    const handleClose = () => {
        setVisible(false)
        setComment('')
        setCommentError('')
    }

    return (
        <RhyBusPopOver
            placement="bottom-right"
            trigger="click"
            popoverclassName="detail-view-cancel-popover action-btn-popover popup-md"
            visible={visible}
            onVisibleChange={setVisible}
            content={
                <div className="d-flex flex-column gap-3 detail-view-popover-form">
                    <RhyBusTextArea
                        id="cancel-comments"
                        label="Comments"
                        value={comment}
                        rows={6}
                        isMandatory
                        placeholder="Enter comments"
                        error={commentError ? true : false}
                        errorMessage={commentError ? commentError : ''}
                        labelClassName='inter-medium font-14'
                        info="Add notes for the selected status update"
                        tooltipPlacement="top"
                        onChange={(e: any) => {
                            setComment(e.target.value)
                            if (e.target.value.trim()) setCommentError('')
                        }}
                    />
                </div>
            }
            footer={
                <div className="d-flex justify-content-end gap-2">
                    <RhyBusButton
                        label={loading ? 'Saving...' : 'Ok'}
                        variant="primary"
                        leftIcon='icon-rb-checked'
                        size="md"
                        disabled={loading}
                        onClick={handleOk}
                    />
                    <RhyBusButton
                        label="Cancel"
                        variant="primary"
                        leftIcon='icon-rb-close font-10 color-primary'
                        size="md"
                        onClick={handleClose}
                        style={{ '--rb-btn-bg': '#FFFFFF', '--rb-btn-border': '#BACBD9', '--rb-btn-text': '#596F80', '--rb-btn-hover-bg': '#fff', '--rb-btn-active-bg': '#fff', '--rb-btn-hover-border': '#BACBD9' }}
                    />
                </div>
            }
        >
            <RhyBusButton
                label="Cancel"
                leftIcon="icon-rb-disable font-16"
                variant="primary"
                pill={true}
                className='cancel-button'
                ariaLabel="Cancel training popup"
                style={{ '--rb-btn-bg': '#B55C2C' }}
            />
        </RhyBusPopOver>
    )
}
